<template>
  <Addresses :bank-address="bankAddress" :main-address="mainAddress" />
</template>

<script>
// Libraries
import { mapActions, mapGetters } from 'vuex'
// Components
import Addresses from '@/reusable/addresses-tab/Addresses'

export default {
  components: {
    Addresses
  },

  provide() {
    return {
      updateProvider: this.updateVendor
    }
  },

  computed: {
    ...mapGetters('vendor-show', ['mainAddress', 'bankAddress'])
  },

  methods: {
    ...mapActions('vendor-show', ['updateVendor'])
  }
}
</script>
